import * as React from 'react';

interface LinkProps {
  label: string;
  onClick?: () => void;
  url?: string;
  external?: boolean;
  className?: string;
  variant?: 'default' | 'monochrome' | 'regular';
  size?: 'small' | 'medium' | 'large';
  customStyle?: React.CSSProperties;
}

const Link: React.FC<LinkProps> = ({
  label,
  onClick,
  url,
  external = false,
  className = '',
  variant = 'default',
  size = 'medium',
  customStyle,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  const getVariantColor = () => {
    switch (variant) {
      case 'monochrome':
        return 'white';
      case 'regular':
        return 'var(--on-surface-default)';
      case 'default':
      default:
        return 'var(--secondary-default)';
    }
  };

  const linkStyle: React.CSSProperties = {
    color: getVariantColor(),
    cursor: 'pointer',
    textDecoration: 'underline',
    textDecorationColor: variant === 'monochrome' ? 'white' : undefined,
    fontSize: size === 'small' ? '12px' : size === 'large' ? '16px' : '14px',
    ...customStyle, // Allow custom styles to override defaults
  };

  if (url) {
    return (
      <a
        href={url}
        target={external ? '_blank' : '_self'}
        rel={external ? 'noopener noreferrer' : undefined}
        className={className}
        style={linkStyle}
        onClick={handleClick}>
        {label}
      </a>
    );
  }

  return (
    <span className={className} style={linkStyle} onClick={handleClick}>
      {label}
    </span>
  );
};

export default Link;
